import { ReactNode } from 'react';
import { Card, CardProps } from '@mui/material';

interface BaseCardProps extends CardProps {
    children: ReactNode;
    className?: string;
}

export default function BaseCard({ children, className, ...props }: BaseCardProps) {
    return (
        <Card className={className} sx={{ padding: '0.5rem 1.5rem', mb: 0.5 }} {...props}>
            {children}
        </Card>
    );
}
